import BackupList from "../../components/productsInfosComponents/BackupComponents/backupList";

const BackupComponent = ({ vmIds }) => {
    return <BackupList vmIds={vmIds} />;
};

export default BackupComponent;